module.exports = __webpack_public_path__ + "img/company-avatar.6d6fed20.png";